export const INFLUENCER_SIDEBAR_MESSAGE_ID = "influencer-sidebar-message";
export const INFLUENCER_SIDEBAR_PRODUCT_VARIANT_ID = "influencer-sidebar-product-variant";
export const INFLUENCER_SIDEBAR_SCROLL_CONTAINER_ID = "influencer-sidebar-scroll-container";
const SCROLL_MARGIN = 16;

const scrollToAndHighlightSidebarSection = ({sectionId}: {sectionId: string}) => {
  requestAnimationFrame(() => {
    const section = document.getElementById(sectionId);
    const scrollContainer = document.getElementById(INFLUENCER_SIDEBAR_SCROLL_CONTAINER_ID);

    if (!section) {
      return;
    }

    if (scrollContainer) {
      const top =
        section.getBoundingClientRect().top -
        scrollContainer.getBoundingClientRect().top +
        scrollContainer.scrollTop -
        SCROLL_MARGIN;
      scrollContainer.scrollTo({top, behavior: "smooth"});
    }

    section.animate(
      [
        {backgroundColor: "#7086ff40", offset: 0},
        {backgroundColor: "#7086ff40", offset: 0.3},
        {backgroundColor: "transparent", offset: 1},
      ],
      {duration: 1200, easing: "ease-out"},
    );
  });
};

export const scrollToInfluencerSidebarMessage = () =>
  scrollToAndHighlightSidebarSection({sectionId: INFLUENCER_SIDEBAR_MESSAGE_ID});

export const scrollToInfluencerSidebarProductVariant = () =>
  scrollToAndHighlightSidebarSection({sectionId: INFLUENCER_SIDEBAR_PRODUCT_VARIANT_ID});
